unit Splash;

interface

uses
  SysUtils, Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.ExtCtrls,
  BaseResponse, Client, Config, LanguageTermList, Login, TermListGetRequest, TermListGetResponse;

type
  TForm_Splash = class(TForm)
    WebImageControl_Splash: TImageControl;
    procedure WebFormResize(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure RestClientOnResult(BaseResponse: TBaseResponse; const Boolean_Error: Boolean);
  private
    { Private declarations }
  protected
    procedure LoadDFMValues; override;
  public
    { Public declarations }
  end;

var
  Form_Splash: TForm_Splash;
  RestClient: TClient;

implementation


procedure TForm_Splash.WebFormResize(Sender: TObject);
begin
  WebImageControl_Splash.Left := (ClientWidth div 2) - WebImageControl_Splash.Width div 2;
  WebImageControl_Splash.Top := (ClientHeight div 2) - WebImageControl_Splash.Height div 2;
end;

procedure TForm_Splash.WebFormShow(Sender: TObject);
var TermListGetRequest: TTermListGetRequest;
begin
  InitConfig(True);

  RestClient := TClient.Create('ERBASOFT', 'Es637485!');
  RestClient.OnResult := RestClientOnResult;

  TermListGetRequest := TTermListGetRequest.Create('Debug', 'nl', 0);

  RestClient.Call('/term/listget', TermListGetRequest, True);

  TermListGetRequest.Free;
end;

procedure TForm_Splash.RestClientOnResult(BaseResponse: TBaseResponse; const Boolean_Error: Boolean);
var Boolean_LoadTerms: Boolean;
    TermListGetResponse: TTermListGetResponse;
begin
  RestClient.Free;

  if not Boolean_Error then
  begin
    TermListGetResponse := BaseResponse as TTermListGetResponse;

    Boolean_LoadTerms := LanguageTermList_Language.LoadLanguageTerms(TermListGetResponse);

    TermListGetResponse.Free;

    if Boolean_LoadTerms then
    begin
      Form_Login := TForm_Login.CreateNew;
      Form_Login.ShowModal;
    end
    else
      ShowMessage('LoadTermsError');
  end
  else
    ShowMessage('RestClientOnResultError');
end;

procedure TForm_Splash.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebImageControl_Splash := TImageControl.Create(Self);

  WebImageControl_Splash.BeforeLoadDFMValues;
  try
    Name := 'Form_Splash';
    Left := 0;
    Top := 0;
    Width := 640;
    Height := 480;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Arial';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebImageControl_Splash.SetParentComponent(Self);
    WebImageControl_Splash.Name := 'WebImageControl_Splash';
    WebImageControl_Splash.Left := 48;
    WebImageControl_Splash.Top := 64;
    WebImageControl_Splash.Width := 534;
    WebImageControl_Splash.Height := 319;
    WebImageControl_Splash.AutoSize := True;
    WebImageControl_Splash.Picture.LoadFromFile('Splash.WebImageControl_Splash.Picture.bmp');
  finally
    WebImageControl_Splash.AfterLoadDFMValues;
  end;
end;

end.
